import Nullstack from 'nullstack';
export default function IconScissorsOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-scissors-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4.432 4.442a3 3 0 1 0 4.114 4.146"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "17",
    r: "3"
  }), "   ", Nullstack.element("path", {
    d: "M8.6 15.4l3.4 -3.4m2 -2l5 -5"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}